import { httpRequest, Response } from '~/networking/utils/httpRequest';
import type { VinovestMoney } from '~/constants/money';
import { getHeaders, getRequestUrl } from '~/networking/client/managed/config';

export interface ProductPriceResponse {
    price: VinovestMoney;
}

export const getProductPrice = async (productId: number): Promise<Response<ProductPriceResponse | undefined>> => {
    const headers = getHeaders(false);
    const url = getRequestUrl(`/public/v1/product/${productId}/market`);
    return httpRequest.get(url, { headers });
};
